import { render, staticRenderFns } from "./recruitment.vue?vue&type=template&id=07b08e44&scoped=true"
import script from "./recruitment.vue?vue&type=script&lang=js"
export * from "./recruitment.vue?vue&type=script&lang=js"
import style0 from "./recruitment.vue?vue&type=style&index=0&id=07b08e44&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b08e44",
  null
  
)

export default component.exports